// @ts-expect-error - Polyfill
if (!Object.groupBy && Array.prototype.group) {
  // @ts-expect-error - Polyfill
  Object.groupBy = (items, keySelector) => [...items].group(keySelector);
}

// @ts-expect-error - Polyfill
if (!Map.groupBy && Array.prototype.groupToMap) {
  Map.groupBy = <K, T>(items: Iterable<T>, keySelector: (item: T, index: number) => K) =>
    // @ts-expect-error - Polyfill
    [...items].groupToMap(keySelector) as Map<K, T[]>;
}
